var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.615 16.982c-.863-.973-2.477-2.437-2.477-7.233 0-3.641-2.431-6.556-5.711-7.273V1.5c0-.83-.638-1.5-1.428-1.5-.788 0-1.427.672-1.427 1.5v.976c-3.28.716-5.711 3.633-5.711 7.275 0 4.794-1.614 6.258-2.477 7.232-.249.276-.386.64-.384 1.017.005.77.579 1.5 1.433 1.5h17.134c.853 0 1.429-.73 1.433-1.5a1.504 1.504 0 00-.384-1.018h-.001zm-16.6.268c.947-1.31 1.983-3.484 1.988-7.473L7 9.75c0-2.9 2.238-5.25 5-5.25 2.761 0 5 2.35 5 5.25l-.004.027c.005 3.99 1.041 6.163 1.988 7.473H5.014zM11.999 24c1.577 0 2.856-1.343 2.856-3H9.144c0 1.657 1.279 3 2.855 3z",
    clipRule: "evenodd"
  })));
}

export default SvgBell;